import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ShapeSubtractIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

/** Boolean subtract — a dashed knife shape cutting a bite out of a filled one. */
export const ShapeSubtractIcon = ({ className, ...props }: ShapeSubtractIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M5 2.5H14.5C15.8807 2.5 17 3.61929 17 5V9.5H13.5C11.8431 9.5 10.5 10.8431 10.5 12.5V16H5C3.61929 16 2.5 14.8807 2.5 13.5V5C2.5 3.61929 3.61929 2.5 5 2.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <rect
      height="11.5"
      rx="2.25"
      stroke="currentColor"
      strokeDasharray="2.6 1.8"
      strokeWidth="1.5"
      width="11.5"
      x="9.75"
      y="9.75"
    />
  </svg>
);

export default ShapeSubtractIcon;
